export enum AvailabilityLabel {
  None = '',
  RequestAccess = 'Request Access',
  Active = 'Active',
  Beta = 'Beta',
  ComingSoon = 'Coming Soon',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export abstract class CTypeModel<T = any> {
  constructor(model: CTypeModel<T>) {
    this.type = model.type;
    Object.assign(this, model);
  }

  rawGuideUrl = '';
  type: T;
  displayName = '';
  description = '';
  logo = '';
  orderNo: number | null = 0;
  availabilityLabel = '';
  industry: string[] = [];
  color = '';
  articleid = '';
  articleidAuth = '';
  scheduleTime = 0;
  documentationUrl = '';
  isAirbyte = false;
  hasIncremental = false;
  pictureUrl?: string = '';
  authTutorial?: string = '';
  useNewTriggerEndpoint?: boolean = false;
  hideV2unsupported?: boolean;
}
